import clsx from 'clsx'
import React from 'react'

interface ContainerListItemProps {
  children?: React.ReactNode;
  icon?: React.ComponentType<{
    'aria-hidden'?: boolean | 'false' | 'true';
    size?: string | number;
  }>;
  heading: React.ReactNode;
  layout?: 'left' | 'centered'
  iconVariant?: 'primary' | 'gray'
  shadow?: boolean
}

function ContainerListItem ({ children, heading, icon: Icon, layout = 'left', iconVariant = 'primary', shadow = true }: ContainerListItemProps) {
  return (
    <li
      className={clsx(
        'bg-white rounded-2xl border border-gray-200 p-4 text-left',
        {
          shadow,
          'text-left': layout === 'left',
          'text-center': layout === 'centered',
        }
      )}
      role='group'
    >
      <div
        className={clsx('flex gap-2', {
          'flex-col items-center': layout === 'centered',
          'flex-row items-start': layout === 'left',
        })}
      >
        {Icon && (
          <div className={clsx(
            'w-6 h-6 shrink-0 flex items-center justify-center rounded-lg',
            {
              'bg-thatch-200 text-thatch-500': iconVariant === 'primary',
              'bg-gray-100 text-gray-500': iconVariant === 'gray',
            }
          )}
          >
            <Icon size={16} aria-hidden />
          </div>
        )}
        <div className='mt-0.5'>{heading}</div>
      </div>
      {children && (
        <div className='body-sm mt-2 text-gray-500 text-pretty'>
          {children}
        </div>
      )}
    </li>
  )
}

ContainerListItem.displayName = 'ContainerList.Item'

export function ContainerList ({ children }: { children: React.ReactNode }) {
  return <ul className='gap-4 grid xs:grid-flow-col xs:auto-cols-fr items-stretch'>{children}</ul>
}

ContainerList.Item = ContainerListItem
